import React from 'react'
import clsx from 'clsx'

import Heading from '../../components/Heading/Heading'
import Button from '../../components/Button/Button'

export const Cta = ({ otherClasses, toggleFunc }) => {
  const ctaClasses = clsx(otherClasses, 'py-16 bg-[#F2F6FD]')

  return (
    <section className={ctaClasses} data-testid="cta">
      <div className="max-w-[1512px] mx-auto lg:px-0 px-6">
        <Heading
          type="h2"
          otherClasses="text-[27px] lg:text-[36px] text-[#262A31] leading-normal font-semibold mb-6 text-center"
        >
          Get In On The Ground Floor
        </Heading>
        <p className="text-base font-work-sans mb-6 text-center">
          Lowest prices. Highest number of incentives. Access starts here.
        </p>
        <div className="flex items-center gap-4 justify-center">
          <Button
            label="Worksheet"
            variant="tertiary"
            otherClasses="lg:px-8 lg:py-4 px-6 py-2 text-base font-semibold"
            slug={{ current: 'resources/worksheet' }}
          />
          <Button
            label="Book a Call"
            variant="primary"
            onClick={() => toggleFunc('Contact Us')}
            otherClasses="lg:px-8 lg:py-4 px-6 py-2 text-base font-semibold whitespace-nowrap"
          />
        </div>
      </div>
    </section>
  )
}

export default Cta
